import { createReducer } from '@reduxjs/toolkit';
import type { IPrize } from 'types/IPrize';
import { fetchPrizes, createPrize, updatePrize, deletePrize } from 'store/actions/prizeActions';

export interface PrizeState {
  prizes: IPrize[];
  loading: boolean;
  error: string | null;
}

const initialState: PrizeState = {
  prizes: [],
  loading: false,
  error: null,
};

const prizeReducer = createReducer<PrizeState>(initialState, (builder) => {
  builder
    .addCase(fetchPrizes.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchPrizes.fulfilled, (state, action) => {
      state.loading = false;
      state.prizes = action.payload;
    })
    .addCase(fetchPrizes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Fehler beim Laden der Gewinne';
    })
    .addCase(createPrize.fulfilled, (state, action) => {
      state.prizes.push(action.payload);
    })
    .addCase(updatePrize.fulfilled, (state, action) => {
      const index = state.prizes.findIndex((p) => p.id === action.payload.id);
      if (index >= 0) state.prizes[index] = action.payload;
    })
    .addCase(deletePrize.fulfilled, (state, action) => {
      state.prizes = state.prizes.filter((p) => Number(p.id) !== action.meta.arg);
    });
});

export default prizeReducer;
